"use client";
import * as React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

export function Calendar(props: CalendarProps) {
  return (
    <div className="rounded-md border bg-background p-2 text-foreground">
      <DayPicker
        showOutsideDays
        fixedWeeks
        weekStartsOn={0}
        {...props}
      />
    </div>
  );
}

export default Calendar;
